'use strict';
var PZMailShare = function PZMailShare(props) {
    var message = '';
    var mailstatus = '';
    if (props.mailStatus == 'ok') {
        message = 'Mail Sent Successfully!!';
        mailstatus = 'success';
    } else if (props.mailStatus == 'err') {
        message = 'Something Went Wrong!!';
        mailstatus = 'mail-error';
    }
    return React.createElement(
        'div', {
            className: 'mailpopup modal fade',
            role: 'dialog'
        },
        React.createElement(
            'div', {
                className: 'modal-dialog'
            },
            React.createElement(
                'div', {
                    className: 'modal-content'
                },
                React.createElement(
                    'div', {
                        className: 'modal-header'
                    },
                    React.createElement(
                        'button', {
                            type: 'button',
                            className: 'close',
                            'data-dismiss': 'modal',
                            onClick: function onClick(e) {
                                e.preventDefault(), props.closeMailPopup(e);
                            }
                        },
                        '\xD7'
                    ),
                    React.createElement(
                        'h4', {
                            className: 'modal-title'
                        },
                        'Share Your Design'
                    )
                ),
                React.createElement(
                    'div', {
                        className: 'modal-body'
                    },
                    React.createElement(
                        'form', {
                            id: 'mail-form',
                            onSubmit: function onSubmit(e) {
                                e.preventDefault(), props.handleSubmit(e);
                            },
                            method: 'POST'
                        },
                        React.createElement(
                            'div', {
                                className: 'form-group'
                            },
                            React.createElement(
                                'label', {
                                    htmlFor: 'sender'
                                },
                                'Sender Email address:'
                            ),
                            React.createElement('input', {
                                type: 'text',
                                name: 'sendermail',
                                className: 'form-control',
                                value: props.fields.sendermail,
                                onChange: function onChange(e) {
                                    e.preventDefault(), props.handleUserInput(e);
                                }
                            }),
                            React.createElement(
                                'div', {
                                    className: 'errorMsg snd'
                                },
                                props.errors.sendermail
                            )
                        ),
                        React.createElement(
                            'div', {
                                className: 'form-group'
                            },
                            React.createElement(
                                'label', {
                                    htmlFor: 'receiver'
                                },
                                'Receiver Email address (separate multiple by commas):'
                            ),
                            React.createElement('input', {
                                type: 'text',
                                name: 'receivermail',
                                className: 'form-control',
                                value: props.fields.receivermail,
                                onChange: function onChange(e) {
                                    e.preventDefault(), props.handleUserInput(e);
                                }
                            }),
                            React.createElement(
                                'div', {
                                    className: 'errorMsg rcv'
                                },
                                props.errors.receivermail
                            )
                        ),
                        React.createElement(
                            'div', {
                                className: 'form-group'
                            },
                            React.createElement(
                                'label', {
                                    htmlFor: 'message'
                                },
                                'Message:'
                            ),
                            React.createElement('textarea', {
                                name: 'message',
                                className: 'form-control',
                                rows: '5',
                                value: props.fields.message,
                                onChange: function onChange(e) {
                                    e.preventDefault(), props.handleUserInput(e);
                                }
                            })
                        ),
                        React.createElement(
                            'div', {
                                className: '' + mailstatus
                            },
                            message
                        ),
                        React.createElement(
                            'button', {
                                type: 'submit',
                                className: 'submit'
                            },
                            'Submit'
                        )
                    )
                ),
                React.createElement('div', {
                    className: 'modal-footer'
                })
            )
        )
    );
};
